module.exports = __webpack_public_path__ + "static/5-cd1f64907ee13b7d71fe77d79d65f98c.jpg";